export interface ColorTheme {
  id: string
  name: string
  accent: string
  accentAlt: string
  orbGradient1: string
  orbGradient2: string
  orbGradient3: string
  light: {
    bg: string
    bgCard: string
    bgCardSolid: string
    text: string
    textMuted: string
    textSubtle: string
    border: string
    shadow: string
  }
  dark: {
    bg: string
    bgCard: string
    bgCardSolid: string
    text: string
    textMuted: string
    textSubtle: string
    border: string
    shadow: string
  }
}

export const COLOR_THEMES: ColorTheme[] = [
  {
    id: 'purple',
    name: 'Purple',
    accent: '#7d33be',
    accentAlt: '#c4a9e3',
    orbGradient1: '#7d33be',
    orbGradient2: '#c4a9e3',
    orbGradient3: '#582d8c',
    light: {
      bg: '#fcf9f4',
      bgCard: 'rgba(255, 255, 255, 0.75)',
      bgCardSolid: '#ffffff',
      text: '#3a2c25',
      textMuted: '#666666',
      textSubtle: '#808080',
      border: 'rgba(232, 226, 220, 0.6)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.08)'
    },
    dark: {
      bg: '#121220',
      bgCard: 'rgba(26, 26, 26, 0.75)',
      bgCardSolid: '#1a1a1a',
      text: '#f2f2f2',
      textMuted: '#808080',
      textSubtle: '#666666',
      border: 'rgba(42, 36, 32, 0.6)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.4)'
    }
  },
  {
    id: 'red',
    name: 'Red',
    accent: '#f31d01',
    accentAlt: '#f3aea1',
    orbGradient1: '#f31d01',
    orbGradient2: '#f3aea1',
    orbGradient3: '#b22c19',
    light: {
      bg: '#fcf9f4',
      bgCard: 'rgba(255, 255, 255, 0.75)',
      bgCardSolid: '#ffffff',
      text: '#3a2c25',
      textMuted: '#666666',
      textSubtle: '#808080',
      border: 'rgba(232, 226, 220, 0.6)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.08)'
    },
    dark: {
      bg: '#121220',
      bgCard: 'rgba(26, 26, 26, 0.75)',
      bgCardSolid: '#1a1a1a',
      text: '#f2f2f2',
      textMuted: '#808080',
      textSubtle: '#666666',
      border: 'rgba(42, 36, 32, 0.6)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.4)'
    }
  },
  {
    id: 'green',
    name: 'Green',
    accent: '#00c853',
    accentAlt: '#7afeaa',
    orbGradient1: '#00c853',
    orbGradient2: '#7afeaa',
    orbGradient3: '#009624',
    light: {
      bg: '#fcf9f4',
      bgCard: 'rgba(255, 255, 255, 0.75)',
      bgCardSolid: '#ffffff',
      text: '#3a2c25',
      textMuted: '#666666',
      textSubtle: '#808080',
      border: 'rgba(232, 226, 220, 0.6)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.08)'
    },
    dark: {
      bg: '#121220',
      bgCard: 'rgba(26, 26, 26, 0.75)',
      bgCardSolid: '#1a1a1a',
      text: '#f2f2f2',
      textMuted: '#808080',
      textSubtle: '#666666',
      border: 'rgba(42, 36, 32, 0.6)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.4)'
    }
  },
  {
    id: 'blue',
    name: 'Blue',
    accent: '#1a73e8',
    accentAlt: '#90b4f8',
    orbGradient1: '#1a73e8',
    orbGradient2: '#90b4f8',
    orbGradient3: '#1558b0',
    light: {
      bg: '#fcf9f4',
      bgCard: 'rgba(255, 255, 255, 0.75)',
      bgCardSolid: '#ffffff',
      text: '#3a2c25',
      textMuted: '#666666',
      textSubtle: '#808080',
      border: 'rgba(232, 226, 220, 0.6)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.08)'
    },
    dark: {
      bg: '#121220',
      bgCard: 'rgba(26, 26, 26, 0.75)',
      bgCardSolid: '#1a1a1a',
      text: '#f2f2f2',
      textMuted: '#808080',
      textSubtle: '#666666',
      border: 'rgba(42, 36, 32, 0.6)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.4)'
    }
  }
]

export function getThemeById(id: string): ColorTheme {
  return COLOR_THEMES.find(t => t.id === id) || COLOR_THEMES[0]
}
